// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarWidgets {
  padding: 5px 35px;
}

.sidebarWidget__active {
  background-color: #14b084 !important;
  border-radius: 18px !important;
}

.sidebarWidgets__icons {
  font-size: 35px !important;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 768px) {
  .sidebarWidgets__icons {
    font-size: 25px !important;
  }

  .sidebarWidgets {
    padding: 10px 20px;
  }
  .sidebarWidget__active {
    border-radius: 16px !important;
    background-color: #14b084 !important;
  }
  .sidebarWidgets__title {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SidebarWidgets.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebarWidgets {\r\n  padding: 5px 35px;\r\n}\r\n\r\n.sidebarWidget__active {\r\n  background-color: #14b084 !important;\r\n  border-radius: 18px !important;\r\n}\r\n\r\n.sidebarWidgets__icons {\r\n  font-size: 35px !important;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .sidebarWidgets__icons {\r\n    font-size: 25px !important;\r\n  }\r\n\r\n  .sidebarWidgets {\r\n    padding: 10px 20px;\r\n  }\r\n  .sidebarWidget__active {\r\n    border-radius: 16px !important;\r\n    background-color: #14b084 !important;\r\n  }\r\n  .sidebarWidgets__title {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
